import React, { useEffect } from "react";

import { getTransData } from "../../services/translateApi";

import useStyles from "./style";

const Transcard = ({
  finalText,
  outputText,
  setOutputText,
  orgLang,
  transLang,
}) => {
  const classes = useStyles();
  useEffect(() => {
    getTransData(finalText, orgLang, transLang).then((data) =>
      setOutputText(data)
    );
  }, []);

  if (
    outputText === undefined ||
    outputText.responseData === undefined ||
    outputText.responseData.translatedText === undefined
  ) {
      return <></>
  }

  console.log({finalText,orgLang,transLang});

  return (
    <>
      <label>Your Output</label>
      <textarea className={classes.textFeild} defaultValue={outputText.responseData.translatedText}>        
      </textarea>
    </>
  );
};

export default Transcard;
